import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {CLIENT} from '../../../../constants/MicroServiceConstants';
const initialData = {
  parentClientNameData: {},
  allParentClientData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'parentClient',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchParentClientData: (state, action) => {
      state.allParentClientData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postParentClientNameData: (state, action) => {
      state.parentClientNameData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetParentClientData: (state) => {
      state.parentClientNameData = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postParentClientNameData,
  resetMsg,
  fetchStart,
  resetParentClientData,
  fetchError,
  fetchParentClientData,
} = slice.actions;

export const fetchParentClients = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/parentclient`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchParentClientData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postParentClientName = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT}/search/parentclientname`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postParentClientNameData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetParentClient = () => {
  return (dispatch) => {
    dispatch(resetParentClientData());
  };
};
